import { createSlice } from '@reduxjs/toolkit';

import { paymentsApi } from '../../../services/payments';

export type Plan = {
  id: string;
  active: boolean;
  planCode: PlanCode;
  createdDate: string; // ISO date string
  updatedDate: string; // ISO date string
  name: string;
  tagline: string;
  sortOrder: number;
  isModuleBasedPlan: boolean;
  design: PlanDesign;
  moduleBasedPricing: ModuleBasedPricing[];
  priceDTO: PlanPrice;
  description: PlanDescription;
  features: PlanFeature;
  button: PlanButton;
  colors: PlanColors;
};

export type PlanCode = 'FREE' | 'PRO' | 'PREMIUM' | string;

export type PlanDesign = {
  icon: string;
  borderColor: string;
  highlight: boolean;
  badge?: PlanBadge;
};

export type PlanBadge = {
  text: string;
  backgroundColor: string;
  textColor: string;
};

export type PlanPrice = {
  displayText: string;
  originalAmount: number;
  enableOfferPrice: boolean;
  offerAmount: number;
  billingText: string;
  validityInMonths: number;
  providedModules: number[];
};

export type ModuleBasedPricing = {
  moduleCode: number;
  moduleName: string;
  price: number;
  validityInMonths: number;
};

export type PlanDescription = {
  text: string;
  color: string;
  fontSize: string;
};

export type Item = {
  item: string;
  availableForThisPlan: boolean;
  sortOrder: number;
};

export type PlanFeature = {
  title: string;
  items: Item[];
};

export type PlanButton = {
  text: string;
  textColor: string;
  backgroundColor: string;
  borderColor: string;
};

export type PlanColors = {
  primary: string;
  secondary: string;
  bgPrimary: string;
  bgSecondary: string;
};

type PaymentState = {
  paymentsData: Plan[];
  popUpPlanMessage: string;
  upgradeDialogOpen: boolean;
  paymentCoupnsData: PaymentCoupns[];
};

export type PaymentCoupns = {
  couponCode: string;
  couponName: string;
  description: string;
};

const initialState: PaymentState = {
  paymentsData: [],
  popUpPlanMessage: '',
  upgradeDialogOpen: false,
  paymentCoupnsData: []
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setPlansPopUpOpen: (state, action) => {
      state.upgradeDialogOpen = action.payload;
    },
    setpopUpPlanMessage: (state, action) => {
      state.popUpPlanMessage = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      paymentsApi.endpoints.getPlans.matchFulfilled,
      (state, action) => {
        state.paymentsData =
          action.payload.data?.filter((plan: Plan) => plan?.active) || [];
      }
    );
    builder.addMatcher(
      paymentsApi.endpoints.getCoupns.matchFulfilled,
      (state, action) => {
        state.paymentCoupnsData = action.payload.data;
      }
    );
  }
});

export const { setPlansPopUpOpen, setpopUpPlanMessage } = paymentsSlice.actions;

export default paymentsSlice.reducer;
